import './theme.css';
import './style.css';
import { lazy, Suspense } from 'react';
import NavBox from './components/NavBox/NavBox';
import './mobile.css';

// three.js is large; load the 3D background in its own chunk so the page appears first
const Background = lazy(() => import('./components/Background'));

function App() {
  return (
    <div className='App'>
    <Suspense fallback={null}>
      <Background />
    </Suspense>
    <NavBox />
    </div>
  );
}

export default App;
